<div class="upload-file {{ type }}" [ngClass]="{'droping': hasBaseDropZoneOver}" ng2FileDrop (fileOver)="fileOverBase($event)" [uploader]="uploader">

  @if (showDropArea) {
    <div class="uploadArea">
      <i class="material-icons color-primary">file_upload</i>
      <p class="text-primary text-bold mb-0">{{titleCopy}}</p>
      <p class="text-small text-secondary">{{descriptionCopy}}</p>
      @if (!uploading) {
        <label class="custom-file">
          <input style="display:none" type="file" class="custom-file-input" ng2FileSelect [uploader]="uploader" [accept]="allowedMimeType.join(',')" />
          <span class="btn btn-sm btn-primary">
            {{ btnCopy }}
          </span>
        </label>
      }
      @if (uploading) {
        <app-loader />
      }
      @if (errorMsg) {
        <app-alert type="danger" [msg]="errorMsg" />
      }
    </div>
  }

  @if (!showDropArea) {
    @if (!uploading) {
      <label class="custom-file">
        <input style="display:none" type="file" class="custom-file-input" ng2FileSelect [uploader]="uploader" [accept]="allowedMimeType.join(',')" />
        <span class="btn btn-sm btn-primary">
          {{ btnCopy }}
        </span>
      </label>
    }
    @if (uploading) {
      <app-loader />
    }
    @if (errorMsg) {
      <app-alert type="danger" [msg]="errorMsg" />
    }
  }

</div>


